import { render, staticRenderFns } from "./CmgNooHomePage.vue?vue&type=template&id=8dc06946&scoped=true&lang=pug"
import script from "./cmg-noo-home-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-noo-home-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNooHomePage.vue?vue&type=style&index=0&id=8dc06946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc06946",
  null
  
)

export default component.exports